import { useEffect, } from "react";
import { useIntl, } from "react-intl";
import { useNavigate, } from 'react-router';
// import { useFetchAuth } from '../authentication/auth';
import { Space, Button, } from 'antd';
import notification from '../notification';
import { ArrowSquareOutIcon, } from "@phosphor-icons/react";

// Inspired by: https://www.delftstack.com/howto/react/use-react-hooks-with-websockets/

const WebSocketElement = ({
    ...props

}) => {
    const intl = useIntl()
    const history = useNavigate();
    const localdata = sessionStorage.getItem('authentication');
    const { customer_id, username, } = JSON.parse(localdata) || {};
    const { setReloadRequestedContent } = props;

    useEffect(() => {
        if (customer_id) {
            wsConnect();
        }

        function pingWebSocket(ws) {
            setTimeout(() => {
                ws.send(JSON.stringify({ event: "ping" }));
                pingWebSocket(ws);
            }, 60000);
        };

        function wsConnect() {
            const ws = new WebSocket(`${process.env.REACT_APP_WEBSOCKET}?customer_id=${customer_id}&user_id=${username}`)

            // Send ping command after 10sec.
            setTimeout(() => {
                pingWebSocket(ws);
            }, 5000);

            ws.onopen = () => {
                ws.send(JSON.stringify({
                    event: "$connect",
                    data: { customer_id: customer_id }
                }));
            };

            ws.onmessage = function (event) {
                const json = JSON.parse(event.data);
                try {

                    if (json.status) {
                        if (json.type === "error") {
                            notification[json.type || 'info']({
                                message: intl.formatMessage({ id: json.subject }),
                                description: intl.formatMessage({ id: json.msg }),
                                duration: 120,
                                placement: 'bottomRight',
                            });
                        } else {
                            var actions = "";

                            // check if link exist in the data object
                            if (json.data.link) {
                                actions = (<Space>
                                    <Button
                                        // type="primary"
                                        size="small"
                                        onClick={() => history(json.data.link)}
                                        icon={<ArrowSquareOutIcon size={16} className="mr-1" />}>
                                        {intl.formatMessage({ id: json.data.link_label })}
                                    </Button>
                                </Space>);
                            }

                            if (json.data.reload) {
                                setReloadRequestedContent(json.data.reload);
                            }
                            notification[json.type || 'info']({
                                message: intl.formatMessage({ id: json.subject }),
                                description: intl.formatMessage({ id: json.msg }),
                                placement: 'bottomRight',
                                actions,
                            });
                        }
                    }
                } catch (err) {
                    console.error(err);
                }
            };

            ws.onclose = function (e) {
                console.warn('Socket is closed. Reconnect will be attempted in 1 second.', e.reason);
                setTimeout(function () {
                    wsConnect();
                }, 1000);
            };
        };
        // eslint-disable-next-line
    }, [customer_id]);

    return null

};

export default WebSocketElement;